<template>
  <div class="sky-hc-bd">
    <div class="block">
      <el-button class="" @click="handleBack">{{ $t('back') }}</el-button>
    </div>
    <div class="block">
      <h4 class="sky-hc-bd__title">
        {{ $t('activeOrg.behaviorTerminalDtl', { terminalName: terminalName }) }}
      </h4>
      <el-timeline class="sky-hc__time-line sky-hc-bd__time-line">
        <el-timeline-item
          v-for="behavior in behaviorList"
          :key="behavior.id"
          :timestamp="formatTime(behavior.updateTime, 'yyyy-MM-dd HH:mm:ss')"
          placement="top"
        >
          <h4>{{ behavior.name }}</h4>
          <p>{{ behavior.description }}</p>
        </el-timeline-item>
      </el-timeline>
      <div class="sky-hc-bd__btn-wrapper" v-if="showLoadMore">
        <el-button class="sky-hc-bd__btn-more" :disabled="loading" @click="loadMoreBehavior">{{
          $t('whitelist.loadMore')
        }}</el-button>
      </div>

      <div v-show="hasNoData" class="sky-hc-bd__no-data mt-10">{{ $t('whitelist.noData') }}</div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>
<script>
import { Button } from 'element-ui'

import { getBehaviorByTerminal } from '@/api/activeOrganization'
import { formatTime } from '@/utils/index'
import Backtop from '@/views/components/backtop'
import timeline from '@/views/components/timeline'
import timelineItem from '@/views/components/timeline-item'
export default {
  name: 'behaviorTerminalDetail',
  components: {
    elTimeline: timeline,
    elTimelineItem: timelineItem,
    [Button.name]: Button,
    [Backtop.name]: Backtop
  },
  data() {
    return {
      formatTime,
      orgId: this.$route.query.orgId,
      behavior: this.$route.query.behavior,
      behaviorName: this.$route.query.behaviorName,
      orgName: this.$route.query.orgName,
      socketKey: this.$route.query.socketKey,
      terminalName: this.$route.query.terminalName,
      deployInfo: {},
      repurchaseInfo: {},
      page: 0,
      limit: 20,
      count: 10,
      loading: false,
      behaviorList: []
    }
  },
  created() {
    this.initData()
  },
  computed: {
    showLoadMore() {
      return this.behaviorList.length < this.count && !this.loading
    },
    hasNoData() {
      return this.behaviorList.length === 0
    }
  },
  methods: {
    handleBack() {
      this.$router.back()
    },
    initData() {
      this.handleGetBehaviorDtl()
    },
    handleGetBehaviorDtl() {
      if (this.loading) {
        return
      }
      this.loading = true
      const data = {
        orgId: this.orgId,
        socketKey: this.socketKey,
        page: this.page,
        limit: this.limit
      }
      getBehaviorByTerminal(data).then(response => {
        this.behaviorList = this.behaviorList.concat(response.data.content.itemArr)
        this.count = response.data.content.total
        this.loading = false
      })
    },
    loadMoreBehavior() {
      this.page++
      this.handleGetBehaviorDtl()
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-bd) {
  @include e(time-line) {
    margin-left: 20px;
    margin-top: 35px;
  }
  @include e(title) {
    // text-align: center;
    font-size: 16px;
    word-break: break-all;
  }
  @include e(btn-wrapper) {
    padding-left: 198px;
    padding-bottom: 30px;
  }
}
</style>
